// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2U5z9HTuKc1hr0WnOlShTr","icon":"_1wdbZeYQSXYD4NUQUcnc6h","active":"pvJrOryC0Nh0QVgH2M39K"};